import { CreateAxiosInstance } from '@eta/components';
import {
    ITaxPayerProfileManagementClient,
    TaxPayerProfileManagementClient,
} from '../ClientProxy/clientProxy';
import { authService } from '../../Security/Security';

import { NotificationManagementClient, INotificationManagementClient } from './NotificationManagementClient';
import { IntermediariesClient, IIntermediariesClient } from './intermediariesProxy';
import { INationalIdRegistryPublicClient, NationalIdRegistryPublicClient } from './NationalIdRegistryClient';
import { IPosManagementPublicClient, PosManagementPublicClient } from '../POS/PosService';
import { ComplaintManagmentClient, IComplaintManagmentClient } from './complaintsProxy';

function EnsureNotSlashAtEnd(url: string) {
    const lastIndex = url && url?.lastIndexOf('/');
    if (lastIndex !== 1) {
        return url && url?.slice(0, lastIndex || 0);
    }
    return url;
}

const publicPortalUrl = EnsureNotSlashAtEnd(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).REACT_APP_PublicGatewayApiBaseURL
);

export class ServiceCreator {

    public static getTaxPayerProfileManagementClient(
        anonymousCall = false
    ): ITaxPayerProfileManagementClient {
        return new TaxPayerProfileManagementClient({
            authService,
            apiGatewayUrl: publicPortalUrl,
            apiVersion: 1,
            enableAnonymousCall: anonymousCall,
        }, undefined, CreateAxiosInstance(true));
    }

    public static getNotificationClient(): INotificationManagementClient {
        return new NotificationManagementClient({
            authService,
            apiGatewayUrl: publicPortalUrl,
            apiVersion: 1,
        }, undefined, CreateAxiosInstance(true));
    }

    public static getIntermediariesClient(): IIntermediariesClient {
        return new IntermediariesClient({
            authService,
            apiGatewayUrl: publicPortalUrl,
            apiVersion: 1
        }, undefined, CreateAxiosInstance(true));
    }

    public static getNationalIdRegistryClient(): INationalIdRegistryPublicClient {
        return new NationalIdRegistryPublicClient({
            authService,
            apiGatewayUrl: publicPortalUrl,
            apiVersion: 1
        }, undefined, CreateAxiosInstance(true));
    }

    public static getPosManagementPublicClient(): IPosManagementPublicClient {
        return new PosManagementPublicClient({
            authService,
            apiGatewayUrl: publicPortalUrl,
            apiVersion: 1
        }, undefined, CreateAxiosInstance(true));
    }

    public static getComplaintsManagementClient(): IComplaintManagmentClient {
        return new ComplaintManagmentClient({
            authService,
            apiGatewayUrl: publicPortalUrl,
            apiVersion: 1
        }, undefined, CreateAxiosInstance(true));
    }

}
